import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.46836 7.4687C3.17461 7.76245 3.17461 8.23745 3.46836 8.52808L9.46836 14.5312C9.76211 14.825 10.2371 14.825 10.5277 14.5312C10.8184 14.2375 10.8215 13.7625 10.5277 13.4718L5.05898 7.99995L10.5309 2.5312C10.8246 2.23745 10.8246 1.76245 10.5309 1.47183C10.2371 1.1812 9.76211 1.17808 9.47148 1.47183L3.46836 7.4687Z",
		fill: "#F96611"
	})
});
export default SvgChevronLeft;
